import {z} from 'zod';
import {defineToolRegistryManifest} from '../../types/base-tool-types';
import {dataToolSchemas} from '../../utils/schemas';

const toolName = 'update-cms-collection' as const;

const argumentZod = z.object({
  collectionId: dataToolSchemas.collectionId.describe(
    'The ID of the collection to update'
  ),
  displayName: z
    .string()
    .min(1)
    .optional()
    .describe('The new display name of the collection (e.g., "Blog Posts")'),
  singularName: z
    .string()
    .min(1)
    .optional()
    .describe(
      'The new singular name for items in this collection (e.g., "Blog Post")'
    ),
  slug: z
    .string()
    .optional()
    .describe(
      'The new URL slug for the collection (e.g., "blog-posts"). If not provided, existing slug will be kept'
    ),
});

export const updateCMSCollectionManifest = defineToolRegistryManifest({
  id: toolName,
  prettyName: 'Update CMS collection',
  family: 'cms',
  llmTool: {
    name: toolName,
    description:
      'Updates an existing CMS collection properties like display name, singular name, or URL slug. At least one property must be provided to update.',
    inputSchema: argumentZod,
  },
  type: 'server',
  permission: [
    {
      resource: 'SiteCollection',
      action: 'manage',
      resolveResources: (args) => [
        {type: 'SiteCollection', id: args.collectionId},
      ],
    },
  ],
  confirmBeforeExecuting: false,
});

export type UpdateCMSCollectionArgumentType = z.infer<typeof argumentZod>;
